import { useEffect, useState } from 'react'
import { removeWhiteBackground } from '../utils/removeWhiteBackground'

const cache = new Map<string, string>()

/**
 * Returns a version of `src` with its flat white backdrop keyed out.
 * Falls back to the original source if the image cannot be processed.
 */
export function useCutoutImage(src: string, enabled = true): string {
  const [resolved, setResolved] = useState(() => cache.get(src) ?? src)

  useEffect(() => {
    if (!enabled) {
      setResolved(src)
      return
    }

    const cached = cache.get(src)
    if (cached) {
      setResolved(cached)
      return
    }

    let active = true
    removeWhiteBackground(src)
      .then((dataUrl) => {
        cache.set(src, dataUrl)
        if (active) setResolved(dataUrl)
      })
      .catch(() => {
        if (active) setResolved(src)
      })

    return () => {
      active = false
    }
  }, [src, enabled])

  return resolved
}
